import React, { createContext, useContext, useMemo } from 'react';
import { useBreakpoint, type Breakpoint } from '@/hooks/useBreakpoint';

interface ResponsiveContextValue {
  breakpoint: Breakpoint;
  isMobile: boolean;
  isTablet: boolean;
  isCompact: boolean;
  isDesktop: boolean;
}

const ResponsiveContext = createContext<ResponsiveContextValue>({
  breakpoint: 'desktop',
  isMobile: false,
  isTablet: false,
  isCompact: false,
  isDesktop: true,
});

export const ResponsiveProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const breakpoint = useBreakpoint();

  const value = useMemo<ResponsiveContextValue>(() => ({
    breakpoint,
    isMobile: breakpoint === 'mobile',
    isTablet: breakpoint === 'mobile' || breakpoint === 'tablet-portrait',
    isCompact: breakpoint !== 'desktop',
    isDesktop: breakpoint === 'desktop',
  }), [breakpoint]);

  return (
    <ResponsiveContext.Provider value={value}>
      {children}
    </ResponsiveContext.Provider>
  );
};

export function useResponsive(): ResponsiveContextValue {
  return useContext(ResponsiveContext);
}
